import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const Navbar = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();
  const [societies, setSocieties] = useState([]);
  const [selectedSociety, setSelectedSociety] = useState('');
  // eslint-disable-next-line
  const [localAuth, setLocalAuth] = useState(false);

  // Load societies whenever auth state changes or component mounts
  useEffect(() => {
    const loadSocieties = () => {
      const token = localStorage.getItem('accessToken');
      const profileData = localStorage.getItem('profileData');
      
      if (token && profileData) {
        try {
          const parsedProfile = JSON.parse(profileData);
          if (parsedProfile.Orgs && parsedProfile.Orgs.length > 0) {
            setSocieties(parsedProfile.Orgs);
            
            // Get current society ID from localStorage or use first society
            const currentSocietyId = localStorage.getItem('societyId') || parsedProfile.Orgs[0].OrgId;
            setSelectedSociety(currentSocietyId);
            
            // Ensure societyId is set in localStorage
            if (!localStorage.getItem('societyId')) {
              localStorage.setItem('societyId', currentSocietyId);
            }
          }
        } catch (error) {
          console.error('Error parsing profile data:', error);
        }
      }
    };

    loadSocieties();

    // Add event listener for society changes
    window.addEventListener('societyChanged', loadSocieties);

    return () => {
      window.removeEventListener('societyChanged', loadSocieties);
    };
  }, [isAuthenticated]);

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) {
        handleLogoutCleanup();
        return;
      }

      const response = await fetch(
        `${API_URL}/api/v1/auth/logout?access_token=${token}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.ok) {
        console.log('Logout successful');
      } else {
        console.error('Logout failed:', response.status);
      }

      handleLogoutCleanup();
    } catch (error) {
      console.error('Error during logout:', error);
      handleLogoutCleanup();
    }
  };

  const handleLogoutCleanup = () => {
    // Clear societies data
    setSocieties([]);
    setSelectedSociety('');
    localStorage.removeItem('societies');
    localStorage.removeItem('societyId');
    
    // Perform logout
    logout();
    navigate('/login');
  };

  const handleSocietyChange = (e) => {
    const newSocietyId = e.target.value;
    setSelectedSociety(newSocietyId);
    localStorage.setItem('societyId', newSocietyId);
    
    // Dispatch custom event for society change
    window.dispatchEvent(new Event('societyChanged'));
    
    // Reload the page to refresh permissions
    window.location.reload();
  };

  const handleNavigation = (path) => {
    // Only check token if not authenticated
    if (!isAuthenticated) {
      const token = localStorage.getItem('accessToken');
      if (!token) {
        navigate('/login');
        return;
      }
    }
    navigate(path);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img 
          src="/logo.jpg" 
          alt="Society Management" 
          className="nav-logo" 
        />
        <span>Society Connect</span>
      </div>
      
      {(isAuthenticated || localAuth) && societies.length > 0 && (
        <select 
          value={selectedSociety} 
          onChange={handleSocietyChange}
          className="society-select"
        >
          {societies.map(society => (
            <option key={society.OrgId} value={society.OrgId}>
              {society.Name || society.OrgName || 'Unnamed Society'}
            </option>
          ))}
        </select>
      )}
      
      <div className="navbar-menu">
        {(isAuthenticated || localAuth) ? (
          <>
            <button 
              className="nav-item" 
              onClick={() => handleNavigation('/dashboard')}
            >
              Dashboard
            </button>
            <button 
              className="nav-item logout" 
              onClick={handleLogout}
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="nav-item">Login</Link>
            <Link to="/signup" className="nav-item">Sign Up</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 